export default __webpack_public_path__ + "static/media/j.b6394d77.jpg";